var exports = {
  "eB": "Block__XcS9j5",
  "Pi": "Paint__52fDfl",
  "nx": "Selectable__MsbHFY",
  "hP": "hiddenPaint__7InHda",
  "mb": "Bitmap__YynRvf",
  "D7": "StyledText__sOqR3j",
  "KW": "nonSelectable__RWVdw0",
};

module.exports = exports;
